import { useTranslations } from "@/lib/useTranslations";
import type { EditorialChecklistProgress } from "@/lib/editorial-checklist-progress";

type LibraryChecklistProgressProps = {
  progress: EditorialChecklistProgress;
};

export function LibraryChecklistProgress({
  progress,
}: LibraryChecklistProgressProps) {
  const t = useTranslations("common.library");
  const { completed, total } = progress;
  const label = t("checklistProgress", { completed, total });

  if (total === 0) {
    return <span className="text-neutral-400">—</span>;
  }

  return (
    <div
      role="progressbar"
      aria-valuenow={completed}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={label}
      className="flex items-center gap-1.5"
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          aria-hidden
          className={`size-2.5 shrink-0 rounded-full ${
            index < completed ? "bg-emerald-500" : "bg-neutral-200"
          }`}
        />
      ))}
    </div>
  );
}
